import React from 'react';
import { Box, Typography } from '@mui/material';

const IncomingCountdownOverlay = ({
  value,
  label = 'Quiz question incoming',
  accent = '#9C27B0',
}) => {
  if (value === null || typeof value === 'undefined') return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.92)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10,
        flexDirection: 'column',
        textAlign: 'center',
        px: 3,
      }}
    >
      <Typography
        variant="h5"
        sx={{
          color: '#fff',
          textTransform: 'uppercase',
          letterSpacing: 2,
          fontWeight: 700,
          mb: 2,
        }}
      >
        {label}
      </Typography>

      <Box
        sx={{
          position: 'relative',
          width: { xs: 140, md: 200 },
          height: { xs: 140, md: 200 },
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            borderRadius: '50%',
            border: `4px solid ${accent}`,
            opacity: 0.45,
            animation: 'incomingPulse 1.2s ease-in-out infinite',
            '@keyframes incomingPulse': {
              '0%': { transform: 'scale(0.95)', opacity: 0.3 },
              '50%': { transform: 'scale(1)', opacity: 0.7 },
              '100%': { transform: 'scale(1.05)', opacity: 0.3 },
            },
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            inset: 12,
            borderRadius: '50%',
            background: 'rgba(0,0,0,0.65)',
            border: `1px solid ${accent}`,
            boxShadow: `0 0 35px ${accent}66`,
          }}
        />
        <Typography
          variant="h1"
          sx={{
            color: accent,
            fontWeight: 900,
            fontSize: { xs: '4.5rem', md: '5.5rem' },
            textShadow: `0 0 30px ${accent}AA`,
          }}
        >
          {value}
        </Typography>
      </Box>

      <Typography
        variant="subtitle1"
        sx={{
          color: '#bbb',
          letterSpacing: 1,
          textTransform: 'uppercase',
          mt: 2,
        }}
      >
        Get ready...
      </Typography>
    </Box>
  );
};

export default IncomingCountdownOverlay;




